module.exports = __webpack_public_path__ + "static/media/IMG_2120.7f411aaa.jpg";